import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hist_lat'
})
export class HistorialLatPipe implements PipeTransform {
  transform(value: any, itemVal:string ) {
    let items = [];
    for(let item of value){
      items.push(item[itemVal]);
    }
    return items;
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/pipes/historialLat.pipe.ts